import { Box } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import {
  Comment,
  Desktop,
  FileFilled,
  Microphone,
  MicrophoneNegative,
  Settings,
  VideoRecorder,
  VideoRecorderNegative,
} from '@factorialco/factorial-one-react/icons/app'

import { ControlBarButton } from '../ControlBarButton'

interface ControlBarProps {
  handleMicToggle: () => void
  handleCameraToggle: () => void
  handleScreenShareToggle?: () => void
  handleDisconnect?: () => void
  audioEnabled: boolean
  videoEnabled: boolean
  screenShareEnabled?: boolean
  labels: {
    microphone: string
    camera: string
    screenShare?: string
    settings?: string
    exit: string
    toggleChat?: string
    toggleSideBar?: string
  }
  onOpenSettings?: () => void
  browserSupportsScreenSharing?: boolean
  isSideBarOpen?: boolean
  setIsSideBarOpen?: (isSideBarOpen: boolean) => void
  isChatOpen?: boolean
  setIsChatOpen?: (isChatOpen: boolean) => void
  isScreenSharing?: boolean
  pendingMessagesCount?: number
}

export const ControlBar = ({
  handleMicToggle,
  handleCameraToggle,
  handleScreenShareToggle,
  handleDisconnect,
  audioEnabled,
  videoEnabled,
  labels,
  browserSupportsScreenSharing = false,
  onOpenSettings = undefined,
  isSideBarOpen,
  setIsSideBarOpen,
  isChatOpen,
  setIsChatOpen,
  isScreenSharing,
  pendingMessagesCount = 0,
}: ControlBarProps) => {
  return (
    <Box flexDirection="row" gap="s4" alignItems="center" justifyContent="center">
      <ControlBarButton
        label={labels.microphone}
        onClick={handleMicToggle}
        isCanceled={!audioEnabled}
        icon={audioEnabled ? Microphone : MicrophoneNegative}
      />

      <ControlBarButton
        label={labels.camera}
        onClick={handleCameraToggle}
        isCanceled={!videoEnabled}
        icon={videoEnabled ? VideoRecorder : VideoRecorderNegative}
      />

      {browserSupportsScreenSharing && handleScreenShareToggle && (
        <ControlBarButton
          label={labels.screenShare || 'Screen Share'}
          onClick={handleScreenShareToggle}
          isFocused={isScreenSharing}
          icon={Desktop}
        />
      )}
      {(setIsChatOpen || setIsSideBarOpen || onOpenSettings || handleDisconnect) && (
        <Box
          background="grey400"
          style={{
            width: '1px',
            height: '16px',
            margin: '0 8px',
          }}
          borderRadius={{ all: 'abs008' }}
        />
      )}
      {setIsChatOpen && (
        <ControlBarButton
          label={labels.toggleChat || 'Toggle Chat'}
          onClick={() => {
            setIsChatOpen(!isChatOpen)
          }}
          icon={Comment}
          isOpen={isChatOpen}
          pending={pendingMessagesCount > 0 ? pendingMessagesCount : undefined}
        />
      )}
      {setIsSideBarOpen && (
        <ControlBarButton
          label={labels.toggleSideBar || 'Toggle Side Bar'}
          onClick={() => {
            setIsSideBarOpen(!isSideBarOpen)
          }}
          icon={FileFilled}
          isOpen={isSideBarOpen}
        />
      )}

      {onOpenSettings && (
        <ControlBarButton
          label={labels.settings || 'Settings'}
          onClick={onOpenSettings}
          icon={Settings}
        />
      )}
      {handleDisconnect && (
        <Box paddingLeft="s2">
          <Button
            label={labels.exit || 'Exit'}
            onClick={handleDisconnect}
            size="lg"
            variant="default"
          />
        </Box>
      )}
    </Box>
  )
}
